import _ from 'underscore';
import classnames from 'classnames';
import { getInternalWebsiteBaseUrl } from 'web-common/scripts/utils/whitelabelUtils';
import FeatureToggleUtils from '../../FeatureToggleClientUtils';
import sameOriginPath from '../../utils/SameOriginPath';

function firstLetter(name) {
    if (typeof name !== 'string') {
        return '';
    }
    return name && name.charAt(0).toUpperCase() || '';
}

function manageSearchObject(search, data) {
    let newSearch = Object.assign({}, search, data);
    return _.omit(newSearch, (value) => value === '' || value === undefined);
}

function manageFilterObject(array = [], key) {
    let totalQuery = '';
    array.forEach((item) => {
        totalQuery += key + '=' + item.category + ':' + item.keyName + '&';
    });
    return totalQuery;
}

function getScriptData(divId) {
    let e = document.getElementById(divId);
    let text = (e && e.innerHTML) || '{}';
    return JSON.parse(_.unescape(text));
}

function redirectToLogin(req, res) {
    let redirectUrl, decodedUrl;
    try {
        redirectUrl = req.query.redirectUrl || (encodeURIComponent(req.originalUrl));
        decodedUrl = decodeURIComponent(redirectUrl);
    } catch (e) {
        decodedUrl = '';
    }
    let nextUrlWithoutQuery = decodedUrl;
    if (decodedUrl.indexOf('?') > -1) {
        nextUrlWithoutQuery = decodedUrl.substring(0, decodedUrl.indexOf('?'));
    }
    // A value that fails the same-origin check is omitted entirely rather than
    // defaulted to `/`: the previous code passed the (unsafe) value through
    // as-is, so nothing redirected to `/` after login; defaulting the query
    // param instead of dropping it would silently send the user to the domain
    // root post-join instead of leaving the pre-login destination untouched.
    const safePath = sameOriginPath(nextUrlWithoutQuery, null);
    const communityPath = safePath ? `community?redirectUrl=${encodeURIComponent(safePath)}` : 'community';
    const url = getInternalWebsiteBaseUrl(req.event, communityPath);
    res.redirect(302, url);
}

function getFullName(firstName, lastName) {
    return _.compact([
        firstName,
        lastName
    ]).join(' ');
}

function getShapeByTemplate(template) {
    switch (template) {
    case 'trade':
    case 'global':
        return 'square';
    case 'urban':
    case 'classic':
    case 'professional':
    case 'sleek':
        return 'round';
    case 'insider':
        return 'diamond';
    default:
        return 'round';
    }
}

function getImageShapeClassName(clsString, template) {
    let shape = getShapeByTemplate(template);
    return classnames(clsString || '', {
        'round-corners': shape === 'round',
        'diamond-corners': shape === 'diamond'
    });
}

function ensureArray(obj) {
    return _.isUndefined(obj) ? [] : (_.isArray(obj) ? obj : [obj]);
}

function addClass(el, classToAdd) {
    if (!(el)) {
        return;
    }
    let classes = el.className.split(' ');
    var index = classes.indexOf(classToAdd);
    if (index < 0) {
        classes.push(classToAdd);
    }
    el.className = classes.join(' ');
}

function removeClass(el, classToRemove) {
    if (!(el)) {
        return;
    }
    let classes = el.className.split(' ');
    var index = classes.indexOf(classToRemove);
    if (index > -1) {
        classes.splice(index, 1);
    }
    el.className = classes.join(' ');
}

function getRedirectUrl(req) {
    // The result is handed to `window.location.replace()` by ReactBackboneInit,
    // so it has to be a same-origin path. The previous `indexOf('script:')`
    // filter was case-sensitive and let `JAVASCRIPT:` through.
    return sameOriginPath(req.query.redirectUrl, null);
}

const redirectToUrl = (loginUrl, redirectToPath, isEmbedded) => {
    const url = `${loginUrl}?redirectUrl=${redirectToPath}`;
    if (isEmbedded) {
        const win = window.open(url, '_blank');
        win.focus();
    } else {
        window.location = url;
    }
};

function getParameterByName(name) {
    const urlParams = decodeURIComponent(window.location.search);
    const match = RegExp('[?&]' + name + '=([^&]*)').exec(urlParams);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

const capitalize = (name) => {
    const disableCommunityCapitalisation = FeatureToggleUtils.isFeatureEnabled('disableCommunityCapitalisation');
    if (!name){
        return '';
    }
    if (disableCommunityCapitalisation){
        return name;
    }
    const lowercase = name.toLowerCase();
    const capitalized = lowercase.replace(/\b\w/g, l => l.toUpperCase());
    return capitalized;
};
const capitalizePersons=(persons)=> {
    let newPersons = persons && persons.map(person => capitalizePerson(person)) || [];
    return newPersons;
};
const capitalizePerson=(person)=> {
    let newPerson = {
        ...person,
        firstName: capitalize(person.firstName),
        lastName: capitalize(person.lastName)
    };
    return newPerson;
};

const backgroundColorHandler = (cond)=> {
    const bodyEl = document.getElementsByTagName('body')[0];
    switch (cond){
    case 'add':
        bodyEl.classList.add('color-1-background-opacity');
        break;
    case 'remove':
        bodyEl.classList.remove('color-1-background-opacity');
        break;
    }
};

const loadCss = (cssURL) => new Promise((resolve, reject) => {
    if (document.querySelector(`link[href="${cssURL}]"`)) resolve();
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = cssURL;
    document.head.appendChild(link);
    link.onload = () => resolve();
    link.onerror = () => reject();
});

export default {
    firstLetter,
    getScriptData,
    manageSearchObject,
    manageFilterObject,
    getFullName,
    getImageShapeClassName,
    ensureArray,
    addClass,
    removeClass,
    redirectToLogin,
    getParameterByName,
    getRedirectUrl,
    redirectToUrl,
    capitalize,
    capitalizePersons,
    capitalizePerson,
    backgroundColorHandler,
    loadCss
};
